import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, PenTool, BarChart3, FileText } from 'lucide-react';
const tomos = [{
  number: 1,
  title: 'Fundamentos del Polo',
  subtitle: '12 clases resueltas · Actividades por nivel · Resolucionario completo',
  topics: ['Historia y origen del polo', 'El campo de juego y sus medidas', 'Reglamento básico y penales', 'Equipamiento del jugador', 'El caballo de polo y su cuidado', 'Seguridad en el campo', 'Vocabulario técnico', 'Las posiciones en el equipo', 'El mazo: tipos y uso', 'Introducción al handicap']
}, {
  number: 2,
  title: 'Técnica Ecuestre Aplicada al Polo',
  subtitle: '12 clases resueltas · 3 actividades progresivas por clase · Resolucionario',
  topics: ['Posición básica del jinete', 'El trote: control y ritmo', 'El galope: transiciones', 'Frenos y paradas', 'Giros y cambios de dirección', 'Control con una mano', 'El mazo: agarre y posición', 'Golpe Forehand', 'Golpe Backhand', 'Neck Shot', 'Integración caballo + mazo']
}, {
  number: 3,
  title: 'Táctica y Estrategia de Juego',
  subtitle: '12 clases resueltas · Diagramas tácticos · Situaciones resueltas',
  topics: ['¿Qué es la táctica en polo?', 'La línea de pelota en juego', 'El sistema 2-2', 'El sistema 1-3', 'Generando superioridad numérica', 'Defensa y cobertura', 'Transición ataque-defensa', 'El pase táctico', 'Ride-off y hook', 'Situaciones de penal', 'Análisis de partido real']
}, {
  number: 4,
  title: 'Entrenamiento y Preparación Física',
  subtitle: '12 clases resueltas · Protocolos de entrenamiento · Tests físicos incluidos',
  topics: ['El atleta de polo: perfil físico', 'Flexibilidad y movilidad', 'Fuerza funcional', 'Resistencia cardiovascular', 'Equilibrio y propiocepción', 'Velocidad de reacción', 'Nutrición e hidratación', 'Periodización anual', 'Prevención de lesiones', 'Entrenamiento del caballo', 'Semana de competencia']
}, {
  number: 5,
  title: 'Evaluación y Competición',
  subtitle: '12 clases resueltas · Fichas de evaluación · Planilla final del programa',
  topics: ['Sistemas de evaluación en polo', 'Autoevaluación del jugador', 'Evaluación técnica y táctica', 'Preparación mental para competir', 'Organización de torneos', 'El jugador en su primer torneo', 'Análisis post-torneo', 'Plan de desarrollo a largo plazo', 'El rol del docente en competencia', 'Evaluación final del sistema completo']
}];
export function TomosSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-10 md:py-20 relative" data-id="element-178">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        <div className="text-center mb-6 md:mb-10" data-id="element-180">
          <h2 className="text-3xl md:text-5xl font-bold mb-3 md:mb-4" data-id="element-181">
            ¿Qué incluye el Sistema?
          </h2>
          <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-182">
            5 TOMOS con 60 clases resueltas, actividades y resolucionario
            completo
          </p>
        </div>

        <div className="space-y-3" data-id="element-183">
          {tomos.map(tomo => {
          const isOpen = openIndex === tomo.number;
          return <motion.div key={tomo.number} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="glass-card rounded-xl overflow-hidden border-white/10" data-id="element-184">
                <button onClick={() => setOpenIndex(isOpen ? null : tomo.number)} className="w-full px-4 py-4 md:px-6 md:py-5 flex items-center gap-3 md:gap-4 text-left focus:outline-none" data-id="element-185">
                  <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-polo-gold/20 flex items-center justify-center text-polo-gold font-bold text-base md:text-lg border border-polo-gold/30 shrink-0" data-id="element-186">
                    {tomo.number}
                  </div>
                  <div className="flex-grow min-w-0" data-id="element-187">
                    <h3 className="text-base md:text-lg font-bold text-white truncate" data-id="element-188">
                      {tomo.title}
                    </h3>
                    <p className="text-xs md:text-sm text-gray-400 mt-0.5 truncate" data-id="element-189">
                      {tomo.subtitle}
                    </p>
                  </div>
                  <ChevronDown className={`w-5 h-5 text-polo-gold transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-190" />
                </button>

                <AnimatePresence data-id="element-191">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-192">
                      <div className="px-4 pb-4 md:px-6 md:pb-5 border-t border-white/5 pt-3" data-id="element-193">
                        <div className="flex flex-wrap gap-1.5 md:gap-2" data-id="element-194">
                          {tomo.topics.map((topic, i) => <span key={i} className="inline-flex items-center text-xs text-gray-300 bg-white/5 px-2 py-1 rounded-full border border-white/10" data-id="element-195">
                              <span className="w-1 h-1 rounded-full bg-polo-gold mr-1.5" data-id="element-196" />
                              {topic}
                            </span>)}
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <div className="mt-8 md:mt-12 text-center" data-id="element-197">
          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-polo-gold hover:bg-polo-goldHover text-polo-navy font-bold text-lg md:text-xl py-4 px-8 md:py-5 md:px-10 rounded-xl shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all hover:scale-105 active:scale-95" data-id="element-198">
            👉 Quiero los 5 Tomos ahora
          </button>
        </div>
      </div>
    </section>;
}